import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { NotificationTab } from '@interfaces/models/notification';
import { useRouter } from 'next/router';
import VcImage from '@components/atoms/vc-images/vc-image';
import Button from '@components/atoms/button/button';
import { isSelectedUpdatesTab, isSelectedMessagesTab } from '@helpers/utils/notification/notification-utils';
import styles from './notification-empty-list-v2.module.scss';

type NotificationEmptyListProps = {
  selectedTab?: NotificationTab;
};

const NotificationEmptyListV2: FC<NotificationEmptyListProps> = ({ selectedTab }): React.JSX.Element => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const isUpdatesSelected = isSelectedUpdatesTab(selectedTab);
  const isMessagesSelected = isSelectedMessagesTab(selectedTab);

  const handleExploreCta = (): void => {
    router.push(t('LINKS.NEW_IN', '/new-items/'));
  };

  return (
    <div
      className={styles.notificationEmptyList}
      data-cy="notificationEmptyList"
    >
      <div
        className={styles.notificationEmptyList__icon}
        data-cy="notificationEmptyList__icon"
      >
        {isUpdatesSelected && (
          <VcImage
            src={`/images/notification-center/updates.svg`}
            alt="empty-updates"
            width="80"
            height="80"
            shouldUseAssetImage
            aria-hidden={true}
          />
        )}

        {isMessagesSelected && (
          <VcImage
            src={`/images/notification-center/messages.svg`}
            alt="empty-messages"
            width="80"
            height="80"
            shouldUseAssetImage
            aria-hidden={true}
          />
        )}
      </div>
      <p
        className={styles.notificationEmptyList__title}
        data-cy="notificationEmptyList__title"
      >
        {isUpdatesSelected
          ? t('NOTIFICATION_CENTER_SCREEN_TAB_UPDATES_EMPTY_TITLE')
          : t('NOTIFICATION_CENTER_SCREEN_TAB_MESSAGES_EMPTY_TITLE')}
      </p>
      <p
        className={styles.notificationEmptyList__text}
        data-cy="notificationEmptyList__text"
      >
        {isUpdatesSelected
          ? t('NOTIFICATION_CENTER_SCREEN_TAB_UPDATES_EMPTY_DESCRIPTION')
          : t('NOTIFICATION_CENTER_SCREEN_TAB_MESSAGES_EMPTY_DESCRIPTION')}
      </p>
      <Button
        size="large"
        variant="rounded-secondary"
        onClick={handleExploreCta}
      >
        {isUpdatesSelected
          ? t('NOTIFICATION_CENTER_SCREEN_TAB_UPDATES_EMPTY_CTA')
          : t('NOTIFICATION_CENTER_SCREEN_TAB_MESSAGES_EMPTY_CTA')}
      </Button>
    </div>
  );
};

export default NotificationEmptyListV2;
